import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6389f209 = () => interopDefault(import('../pages/a-propos.vue' /* webpackChunkName: "pages/a-propos" */))
const _dbab2908 = () => interopDefault(import('../pages/actu/index.vue' /* webpackChunkName: "pages/actu/index" */))
const _51e61dae = () => interopDefault(import('../pages/comment-staker-vos-ADAs.vue' /* webpackChunkName: "pages/comment-staker-vos-ADAs" */))
const _79b33d7a = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _43907f4c = () => interopDefault(import('../pages/doc-cardano/index.vue' /* webpackChunkName: "pages/doc-cardano/index" */))
const _18495f91 = () => interopDefault(import('../pages/staking.vue' /* webpackChunkName: "pages/staking" */))
const _463ba2df = () => interopDefault(import('../pages/doc-cardano/le-developpement-de-cardano.vue' /* webpackChunkName: "pages/doc-cardano/le-developpement-de-cardano" */))
const _c9d9e2c2 = () => interopDefault(import('../pages/doc-cardano/les-defis-de-cardano.vue' /* webpackChunkName: "pages/doc-cardano/les-defis-de-cardano" */))
const _01425b9f = () => interopDefault(import('../pages/doc-cardano/les-phases-de-cardano-roadmap.vue' /* webpackChunkName: "pages/doc-cardano/les-phases-de-cardano-roadmap" */))
const _0a13e078 = () => interopDefault(import('../pages/doc-cardano/les-portefeuilles-compatibles-avec-le-staking-d-ADA.vue' /* webpackChunkName: "pages/doc-cardano/les-portefeuilles-compatibles-avec-le-staking-d-ADA" */))
const _218c0f26 = () => interopDefault(import('../pages/doc-cardano/qu-est-ce-qu-une-stake-pool.vue' /* webpackChunkName: "pages/doc-cardano/qu-est-ce-qu-une-stake-pool" */))
const _dd3f6d5a = () => interopDefault(import('../pages/doc-cardano/qu-est-ce-que-cardano.vue' /* webpackChunkName: "pages/doc-cardano/qu-est-ce-que-cardano" */))
const _b702343c = () => interopDefault(import('../pages/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA.vue' /* webpackChunkName: "pages/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA" */))
const _bcef6a06 = () => interopDefault(import('../pages/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos.vue' /* webpackChunkName: "pages/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos" */))
const _02535af2 = () => interopDefault(import('../pages/doc-cardano/qu-est-ce-que-le-staking.vue' /* webpackChunkName: "pages/doc-cardano/qu-est-ce-que-le-staking" */))
const _3feea228 = () => interopDefault(import('../pages/tutoriel/comment-choisir-une-stake-pool-pour-deleguer-ses-ADAs.vue' /* webpackChunkName: "pages/tutoriel/comment-choisir-une-stake-pool-pour-deleguer-ses-ADAs" */))
const _3d80be66 = () => interopDefault(import('../pages/tutoriel/comment-staker-ses-ADAs-avec-Adalite.vue' /* webpackChunkName: "pages/tutoriel/comment-staker-ses-ADAs-avec-Adalite" */))
const _32be1cbb = () => interopDefault(import('../pages/tutoriel/comment-staker-ses-ADAs-avec-Daedalus.vue' /* webpackChunkName: "pages/tutoriel/comment-staker-ses-ADAs-avec-Daedalus" */))
const _65d6f290 = () => interopDefault(import('../pages/tutoriel/comment-staker-ses-ADAs-avec-Yoroi.vue' /* webpackChunkName: "pages/tutoriel/comment-staker-ses-ADAs-avec-Yoroi" */))
const _df186b98 = () => interopDefault(import('../pages/actu/_slug.vue' /* webpackChunkName: "pages/actu/_slug" */))
const _2e1c0a64 = () => interopDefault(import('../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _196974d3 = () => interopDefault(import('../pages/auteur/_slug.vue' /* webpackChunkName: "pages/auteur/_slug" */))
const _73fb32e4 = () => interopDefault(import('../pages/definition/_slug.vue' /* webpackChunkName: "pages/definition/_slug" */))
const _35a56acd = () => interopDefault(import('../pages/whaleactivity/_slug.vue' /* webpackChunkName: "pages/whaleactivity/_slug" */))
const _98173ca8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-propos",
    component: _6389f209,
    name: "a-propos"
  }, {
    path: "/actu",
    component: _dbab2908,
    name: "actu"
  }, {
    path: "/comment-staker-vos-ADAs",
    component: _51e61dae,
    name: "comment-staker-vos-ADAs"
  }, {
    path: "/contact",
    component: _79b33d7a,
    name: "contact"
  }, {
    path: "/doc-cardano",
    component: _43907f4c,
    name: "doc-cardano"
  }, {
    path: "/staking",
    component: _18495f91,
    name: "staking"
  }, {
    path: "/doc-cardano/le-developpement-de-cardano",
    component: _463ba2df,
    name: "doc-cardano-le-developpement-de-cardano"
  }, {
    path: "/doc-cardano/les-defis-de-cardano",
    component: _c9d9e2c2,
    name: "doc-cardano-les-defis-de-cardano"
  }, {
    path: "/doc-cardano/les-phases-de-cardano-roadmap",
    component: _01425b9f,
    name: "doc-cardano-les-phases-de-cardano-roadmap"
  }, {
    path: "/doc-cardano/les-portefeuilles-compatibles-avec-le-staking-d-ADA",
    component: _0a13e078,
    name: "doc-cardano-les-portefeuilles-compatibles-avec-le-staking-d-ADA"
  }, {
    path: "/doc-cardano/qu-est-ce-qu-une-stake-pool",
    component: _218c0f26,
    name: "doc-cardano-qu-est-ce-qu-une-stake-pool"
  }, {
    path: "/doc-cardano/qu-est-ce-que-cardano",
    component: _dd3f6d5a,
    name: "doc-cardano-qu-est-ce-que-cardano"
  }, {
    path: "/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA",
    component: _b702343c,
    name: "doc-cardano-qu-est-ce-que-la-cryptomonnaie-ADA"
  }, {
    path: "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos",
    component: _bcef6a06,
    name: "doc-cardano-qu-est-ce-que-le-delegated-proof-of-stake-dpos"
  }, {
    path: "/doc-cardano/qu-est-ce-que-le-staking",
    component: _02535af2,
    name: "doc-cardano-qu-est-ce-que-le-staking"
  }, {
    path: "/tutoriel/comment-choisir-une-stake-pool-pour-deleguer-ses-ADAs",
    component: _3feea228,
    name: "tutoriel-comment-choisir-une-stake-pool-pour-deleguer-ses-ADAs"
  }, {
    path: "/tutoriel/comment-staker-ses-ADAs-avec-Adalite",
    component: _3d80be66,
    name: "tutoriel-comment-staker-ses-ADAs-avec-Adalite"
  }, {
    path: "/tutoriel/comment-staker-ses-ADAs-avec-Daedalus",
    component: _32be1cbb,
    name: "tutoriel-comment-staker-ses-ADAs-avec-Daedalus"
  }, {
    path: "/tutoriel/comment-staker-ses-ADAs-avec-Yoroi",
    component: _65d6f290,
    name: "tutoriel-comment-staker-ses-ADAs-avec-Yoroi"
  }, {
    path: "/actu/:slug",
    component: _df186b98,
    name: "actu-slug"
  }, {
    path: "/articles/:slug?",
    component: _2e1c0a64,
    name: "articles-slug"
  }, {
    path: "/auteur/:slug?",
    component: _196974d3,
    name: "auteur-slug"
  }, {
    path: "/definition/:slug?",
    component: _73fb32e4,
    name: "definition-slug"
  }, {
    path: "/whaleactivity/:slug?",
    component: _35a56acd,
    name: "whaleactivity-slug"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
